import React from 'react'
import { Link, Redirect, Route } from 'react-router-dom'
import { getDoctorActivate, isLogin } from '../utils'

const PrivateActivateRoute = ({ component: Component, ...rest }) => {
    return (
        <Route {...rest} render={props => (
            (isLogin() && getDoctorActivate() === "active") ?
                <Component {...props} />
                :
                isLogin() ? <Redirect to="/" />
                    :
                    <Redirect to="/login" />
        )} />
    );
};

export default PrivateActivateRoute